'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'window-frame';
var width = 448;
var height = 512;
var aliases = [129695];
var unicode = 'e04f';
var svgPathData = 'M416 64l0 400 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-400C32 28.7 60.7 0 96 0L352 0c35.3 0 64 28.7 64 64zM80 232l120 0 0-184-104 0c-8.8 0-16 7.2-16 16l0 168zm120 48l-120 0 0 184 120 0 0-184zm48 0l0 184 120 0 0-184-120 0zm0-48l120 0 0-168c0-8.8-7.2-16-16-16l-104 0 0 184z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWindowFrame = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;